const PRICES = [
  {
    id: 1,
    label: 'Sonic Opening',
    title: 'Day 01',
    price: 25,
    oldPrice: 40,
    accent: 'purple',
    description: 'Best for visitors who want to experience one selected day.',
    features: [
      'Access to 1 festival day',
      'Main stage entry',
      'Standard standing zone',
      'Opening shows & selected attractions',
    ],
  },
  {
    id: 2,
    label: 'The Peak',
    title: 'Day 02',
    price: 35,
    oldPrice: 55,
    accent: 'cyan',
    description:
      'Perfect if you want more music, more artists, and more energy.',
    features: [
      'Access to any 2 festival days',
      'Main stage + side stages',
      'Priority entry lane',
      'More time to explore the full lineup',
    ],
  },
  {
    id: 3,
    label: 'Final Echo',
    title: 'Day 03',
    price: 50,
    oldPrice: 75,
    accent: 'pink',
    description: 'The full festival pass for the complete 3-day experience.',
    features: [
      'Access to all 3 festival days',
      'All stages included',
      'Fast-track festival entry',
      'Best value for full weekend access',
    ],
  },
];

export default PRICES;
